import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import useFeatureWireStore from './state-hooks';
import Option from './option';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 32px;
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 8px;
`;

const Bottom = styled.div`
  border: 1px solid #D7DFE7;
  border-radius: 2px;
  max-height: 320px;
  overflow-y: auto;
  width: 100%;
`;

const Label = styled.div`
  color: ${props => props.theme.secondaryColor};
  font-size: 14px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 120%;
  letter-spacing: -0.02em;
  text-transform: uppercase;
`;

const Action = styled.div`
  color: ${props => props.theme.secondaryColor};
  font-size: 16px;
  font-weight: ${props => props.theme.fontWeightHeavy};

  a.secondary, a.disabled {
    color: ${props => props.theme.secondaryColor};
  }

  a.disabled {
    cursor: unset;
    opacity: 0.5;
    text-decoration: none;
  }

  .separator {
    margin: 0 8px;
  }
`;

export default function Mentions() {
  const set = useFeatureWireStore(state => state.set);
  const mentions = useFeatureWireStore(state => state.featureable.mentions);
  const selected = useFeatureWireStore(state => state.selectedFeatureable);

  if (mentions.length === 0) {
    return null;
  }

  const selectAll = e => {
    e && e.preventDefault();

    set(state => {
      state.selectedFeatureable = _.unionWith(selected, mentions, _.isEqual);
    });
  };

  const clear = e => {
    e && e.preventDefault();

    set(state => {
      state.selectedFeatureable = _.differenceWith(selected, mentions, _.isEqual);
    });
  };

  const selectedMentions = _.intersectionWith(selected, mentions, _.isEqual);
  const clearLinkClass = selectedMentions.length === 0 ? 'disabled' : 'secondary';

  return (
    <Container>
      <Top>
        <Label>Mentions</Label>
        <Action>
          <a href="#" onClick={selectAll}>Select All</a>
          <span className="separator">|</span>
          <a href="#" className={clearLinkClass} onClick={clear}>Clear</a>
        </Action>
      </Top>
      <Bottom>
        {mentions.map(f => <Option key={`${f.type}-${f.id}`} featureable={f} />)}
      </Bottom>
    </Container>
  );
}
